import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import { collection, query, where, orderBy, onSnapshot, limit, updateDoc, doc } from 'firebase/firestore';
import ComposeLetter from './ComposeLetter';
import Mailbox from './Mailbox';
import './LoveLetter.css';

const LoveLetters = () => {
  const [lastUnopenedLetter, setLastUnopenedLetter] = useState(null);
  const [lastLetter, setLastLetter] = useState(null); // For the last letter overall
  const [letterToDisplay, setLetterToDisplay] = useState(null); // The letter currently in the envelope
  const [showCompose, setShowCompose] = useState(false);
  const [showMailbox, setShowMailbox] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [recipientName, ] = useState('My Love'); // setRecipientName is not used, so we can remove it.


  // Fetch the last UNOPENED letter for the "new letter" notification
  useEffect(() => {
    if (!auth.currentUser) return;
    
    const q = query(
      collection(db, 'letters'),
      where('to', '==', auth.currentUser.uid),
      where('isRead', '==', false),
      orderBy('createdAt', 'desc'),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const letter = snapshot.docs[0];
        setLastUnopenedLetter({ id: letter.id, ...letter.data() });
      } else {
        setLastUnopenedLetter(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Fetch the absolute last letter (read or unread) for the "Open Last Letter" button
  useEffect(() => {
    if (!auth.currentUser) return;

    const q = query(
      collection(db, 'letters'),
      where('to', '==', auth.currentUser.uid),
      orderBy('createdAt', 'desc'),
      limit(1)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        const letter = snapshot.docs[0];
        setLastLetter({ id: letter.id, ...letter.data() });
      } else {
        setLastLetter(null);
      }
    });

    return () => unsubscribe();
  }, []);

  const openLetter = async (letter) => {
    if (!letter) return;
    setLetterToDisplay(letter);
    setIsOpen(true);
    // Mark as read if it's not already
    if (!letter.isRead) {
      const letterRef = doc(db, 'letters', letter.id);
      await updateDoc(letterRef, {
        isRead: true,
      });
    }
  };

  const handleLetterSent = () => {
    setShowCompose(false);
  };

  const handleCloseLetter = () => {
    setIsOpen(false);
    // Don't clear the letterToDisplay, so it can be reopened if needed
  }

  if (showCompose) {
    return <ComposeLetter onLetterSent={handleLetterSent} onBack={() => setShowCompose(false)} />;
  }

  if (showMailbox) {
    return <Mailbox onBack={() => setShowMailbox(false)} onSelectLetter={(letter) => openLetter(letter)} />;
  }

  return (
    <div className={`love-letter-container ${showMailbox ? 'mailbox-view' : ''}`}>
      <link
        href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&display=swap"
        rel="stylesheet"/>
      <div className="envlope-wrapper">
        <div id="envelope" className={isOpen ? 'open' : 'close'}>
          <div className="front flap"></div>
          <div className="front pocket"></div>
          <div className="letter">
            <div className="words line1">To: {recipientName}</div>
            <div className="words line2">{letterToDisplay?.message}</div>
            <div className="words line3">- {letterToDisplay?.fromName}</div>
          </div>
          <div className="hearts">
            <div className="heart a1"></div>
            <div className="heart a2"></div>
            <div className="heart a3"></div>
          </div>
        </div>
      </div>
      <div className="reset">
        {isOpen && <button id="reset" onClick={handleCloseLetter} className="action-button">Close</button>}
        {lastUnopenedLetter && !isOpen && (
          <button onClick={() => openLetter(lastUnopenedLetter)} className="action-button">You have a new letter!</button>
        )}
        {!lastUnopenedLetter && lastLetter && !isOpen && (
          <button onClick={() => openLetter(lastLetter)} className="action-button">Open Last Letter</button>
        )}
        <button onClick={() => setShowCompose(true)} className="action-button">Compose Letter</button>
        <button onClick={() => setShowMailbox(true)} className="action-button">Mailbox</button>
      </div>
    </div>
  );
};

export default LoveLetters;